import React, { useRef, useState } from 'react';
import { useClerk, useUser } from '@clerk/clerk-react';
import Sidebar from './Sidebar';

type LayoutProps = {
  children: React.ReactNode;
};

function getInitials(firstName?: string | null, lastName?: string | null): string {
  const f = firstName?.trim()[0] ?? '';
  const l = lastName?.trim()[0] ?? '';
  return (f + l).toUpperCase() || 'U';
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { signOut } = useClerk();
  const { user, isLoaded } = useUser();
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  const initials = isLoaded ? getInitials(user?.firstName, user?.lastName) : 'U';
  const fullName = isLoaded && user ? [user.firstName, user.lastName].filter(Boolean).join(' ') : null;

  const handleSignOut = async () => {
    await signOut();
    window.location.replace('/');
  };

  return (
    <div className="min-h-screen bg-white">
      <Sidebar />

      <div className="pl-[180px]">
        <header className="bg-white h-16 border-b border-gray-200 flex items-center justify-between px-6">
          <div />
          <div className="flex items-center space-x-4">
            <div className="relative">
              <div
                ref={buttonRef}
                className="w-8 h-8 rounded-full border border-gray-400 flex items-center justify-center cursor-pointer select-none"
                style={{ background: '#29446D' }}
                onClick={() => setOpen((o) => !o)}
              >
                <span
                  className="text-white font-bold"
                  style={{ fontSize: '14px', fontFamily: 'Roboto, sans-serif', fontWeight: '700' }}
                >
                  {initials}
                </span>
              </div>

              {open && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />
                  <div className="absolute right-0 mt-2 w-52 rounded-md bg-white border border-gray-200 shadow-lg z-20 py-1">
                    {fullName && (
                      <div className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100 font-medium">
                        {fullName}
                      </div>
                    )}
                    <button
                      type="button"
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={handleSignOut}
                    >
                      Sign out
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </header>

        <main className="px-[6.5rem] pb-[6.5rem] pt-[25px]">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
